
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getMunicipalities",
      resolverType: "query",
      routePath: "/getMunicipalities",
      httpMethod: "POST",
    });
  